import { ArrowRight, X } from "lucide-react";
import { useAuth } from "../../../../../context/AuthContext";
import { dictionary } from "../../../../../utils/dictionary";

const ConnectButton = ({ onClick, loading }: { onClick: () => void, loading: boolean }) => {
  const { language } = useAuth();
  return (
    <button
      onClick={onClick}
      className="w-full py-2 px-4 text-sm font-semibold border border-red-600 text-red-600 hover:bg-red-100 rounded-lg flex items-center justify-between transition-colors"
    >
      {loading ? dictionary?.["loading"]?.[language] || "Cargando..." : dictionary["cancel"][language]} <X size={16} />
    </button>
  );
};

export default ConnectButton;
